module.exports = __webpack_public_path__ + "static/img/shiptrack3.985c51c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/shiptrack3.png
// module id = iJPB
// module chunks = 0